import { render, staticRenderFns } from "./CadastroPedagogicoView.vue?vue&type=template&id=e1ef024c&scoped=true"
import script from "./CadastroPedagogicoView.vue?vue&type=script&lang=js"
export * from "./CadastroPedagogicoView.vue?vue&type=script&lang=js"
import style0 from "./CadastroPedagogicoView.vue?vue&type=style&index=0&id=e1ef024c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ef024c",
  null
  
)

export default component.exports